// TODO: Document all these constants
export const BROWSER_FULLSCREEN_REQUEST = [
	'requestFullscreen',
	'webkitRequestFullscreen',
	'webkitRequestFullScreen',
	'webkitCancelFullScreen',
	'mozRequestFullScreen',
	'msRequestFullscreen'
];

export const BROWSER_FULLSCREEN_ELEMENT = [
	'fullscreenElement',
	'webkitFullscreenElement',
	'webkitCurrentFullScreenElement',
	'mozFullScreenElement',
	'msFullscreenElement'
];

export const BROWSER_FULLSCREEN_EXIT = [
	'exitFullscreen',
	'webkitExitFullscreen',
	'webkitCancelFullScreen',
	'mozCancelFullScreen',
	'msExitFullscreen'
];

export const BROWSER_FULLSCREEN_CHANGE = ['fullscreenchange', 'webkitfullscreenchange', 'mozfullscreenchange', 'MSFullscreenChange'];

/**
 * Array of supported locales.
 * This const is used across multiple files, before changing its structure
 * consult all the ways it is being used.
 * @constant
 * @type {string[]}
 * @default ['es-es', 'fr-fr']
 */
export const LOCALES = ['es-es', 'fr-fr'];
export const LOCALES_REGEX = /[A-Za-z]{2,3}-[A-Za-z]{2,3}$/;

export const COUNTRIES = { FRANCE: 'fr', SPAIN: 'es' };

export const SPECIAL_LOCATIONS = { 'es-es': ['ceuta', 'melilla', 'andorre'], 'fr-fr': ['monaco', 'andorre'] };

// TODO: This has to be the same like the on in next.config.mjs. Is there a way to import it?
// This path should not have a trailing slash.
export const BASE_PATH = '/cars/bz4x/build';

// Mapbox places will only show places in these markets from the countries in the list
// Example: For France market fr,mc will show places in France and Monaco
export const MAPBOX_LOCALES = {
	fr: { countryCode: 'fr,mc', languageCode: 'fr' }, // France, Monaco
	es: { countryCode: 'es,ad', languageCode: 'es' } // Spain, Andorra
};

// A2D regions that should be filtered out from the search results. Corrlates with MAPBOX_LOCALES above.
// Example: For France market will filter out the region "PRINCIPAUTE D'ANDORRE" because even if Mapbox won't return it as per the above A2D will still do it.
export const A2D_FILTERED_REGIONS = { fr: ["PRINCIPAUTE D'ANDORRE"], es: [] };

// Some countries may have regions where dealerships do not exist of ship to. For example
// the Canary Islands in Spain.
export const REGIONS_NOT_SOLD_TO_BY_COUNTRY = { es: ['Santa Cruz de Tenerife', 'Las Palmas', 'Canary Islands'] };

// Regions where customers cannot purchase online and must contact retailer directly.
// Ceuta and Melilla - pricing cannot be configured correctly in Rockar.
export const REGIONS_BLOCKED_FOR_CUSTOMERS = { es: ['ceuta', 'melilla'] };

// When we get the CarDB packs we need to filter out some types, this is the list of types to filter out based on the pack Type.
export const ALLOWED_PACK_TYPES = ['EQUIPMENT'];

export const CARDB_ENV_PERF_CODE = 'ENVPERF';
export const CARDB_EXTERIOR_CODE = 'EXT';
export const CARDB_INTERIOR_CODE = 'INT';

// Name of the cookie we use for cp auth
export const CP_SESSION_KEY = 'cp-session';
